import { TbRosetteDiscount } from "react-icons/tb";
import FormTitle from "../../../components/FormTitle/FormTitle";
import { useEffect, useState } from "react";
import { useListManager } from "../../../contexts/list.manager";
import { useNavigate } from "react-router-dom";
import Loader from "../../../components/Loader/Loader";
import Form from "../../../components/Form/Form";
import Input from "../../../components/Input/Input";
import TextAreaInput from "../../../components/TextAreaInput/TextAreaInput";
import LicenseService from "../../../services/LicensesService";
import { wait } from "../../../utils/timer";

export function FormDiscountReason({ title, ...props }) {
   const [code, setCode] = useState(props.discountReason?.code);
   const [name, setName] = useState(props.discountReason?.name);
   const [description, setDescription] = useState(props.discountReason?.description);
   const [metadata, setMetadata] = useState(props.discountReason?.metadata);

   const [isSubmitting, setIsSubmitting] = useState(false);
   const [showLoader, setShowLoader] = useState(false);
   const { closeForm } = useListManager();
   const navigate = useNavigate();

   useEffect(() => {
      setCode(props.discountReason?.code || "");
      setName(props.discountReason?.name || "");
      setDescription(props.discountReason?.description || "");
      setMetadata(props.discountReason?.metadata || "");
   }, [props.discountReason])

   function buildPayload() {
      const payload = {
         code,
         name,
         description,
         metadata,
      };
      return payload;
   }

   async function handleSubmit(event) {
      event.preventDefault();
      if (props.type === "edicao") {
         setIsSubmitting(true);
         await handleEdit(event);
         setIsSubmitting(false);
         return;
      }
      setIsSubmitting(true);
      const payload = buildPayload();
      const response = await LicenseService.createDiscountReason(payload);
      if (!response) return;
      if (response.data.id) navigate("/licenses/discount-reasons", {
         state: { refresh: true }
      });
      setIsSubmitting(false);
   }

   async function handleEdit(event) {
      event.preventDefault();
      const payload = buildPayload();
      const response = await LicenseService.updateDiscountReason(
         props.discountReason.id,
         payload
      );
      closeForm();
      if (response.data.id) navigate("/licenses/discount-reasons");
   }

   async function handleDelete() {
      if (!props.discountReason) return;
      await LicenseService.deleteDiscountReason(props.discountReason.id);
      navigate("/licenses/discount-reasons", {
         state: { deletedId: props.discountReason.id },
      });
   }

   const handleClickEditButton = () => {
      if (!props.discountReason) return;
      navigate(`/licenses/discount-reasons/${props.discountReason.externalId}`, { state: props.discountReason });
   };

   return (
      <>
         <FormTitle
            type={props.type}
            icon={<TbRosetteDiscount size={20} />}
            tituloConsulta={props.discountReason?.name || null}
            tituloCadastro={title || "Cadastro de Motivo de desconto"}
            backRoute={"/licenses/discount-reasons"}
         />
         {showLoader ? (
            <Loader />
         ) : (
            <Form
               handleSubmit={handleSubmit}
               handleClickEdit={handleClickEditButton}
               type={props.type}
               handleDelete={handleDelete}
               navigateCancelUrl="/licenses/discount-reasons"
               isSubmitting={isSubmitting}
            >
               <div className={props.type === 'consulta' ? `w-full` : 'grid-2'}>
                  <Input
                     name="name"
                     id="name"
                     labelText="Nome *"
                     value={name}
                     onChange={({ target }) => setName(target.value)}
                     disabled={props.type === "consulta" || isSubmitting}
                     required={true}
                  />
                  <Input
                     name="code"
                     id="code"
                     labelText="Código *"
                     value={code}
                     onChange={({ target }) => setCode(target.value)}
                     disabled={props.type === "consulta" || isSubmitting}
                     required={true}
                  />
               </div>
               <TextAreaInput
                  name={"description"}
                  id="description"
                  labelText={"Informações extras"}
                  onChange={({ target }) => setDescription(target.value)}
                  value={description}
                  hidden={props.type === "consulta" || isSubmitting}
                  rows={3}
               />
            </Form>
         )}
      </>
   );
}